import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {Observable} from "rxjs";
import { DocumentDto } from 'src/app/auto-generated-server-dtos/claim/files/document-dto';

@Injectable({
  providedIn: 'root'
})
export class ListUploadedFilesService {

  constructor(private httpClient: HttpClient) { }

  listUploadedFiles(claimId: number) : Observable<DocumentDto[]> {
    return this.httpClient.get<DocumentDto[]>(`${environment.apiServer}/ListUploadedFilesByClaim`, {params: {claimId: claimId}});
  }
}
